import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'containers/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import { ABOVE_THE_HEADER, BELOW_THE_HEADER, COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION } from 'constants/ActionTypes';
import { isIOS, isMobile } from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import InitialLoadingScreen from 'containers/InitialLoadingScreen';

class App extends React.Component {
    render() {
        const { match, drawerType, navigationStyle, horizontalNavPosition } = this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER)
            ? 'fixed-drawer'
            : drawerType.includes(COLLAPSED_DRAWER)
            ? 'collapsible-drawer'
            : 'mini-drawer';

        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            document.body.classList.add('ios-mobile-view-height');
        } else if (document.body.classList.contains('ios-mobile-view-height')) {
            document.body.classList.remove('ios-mobile-view-height');
        }
        return (
            <div className={`app-container ${drawerStyle}`}>
                <InitialLoadingScreen />
                <Sidebar userRole={this.props.userRole} />
                <div className="app-main-container">
                    <div className="app-header">
                        <Header />
                    </div>

                    <main className="app-main-content-wrapper">
                        <div className="app-main-content">
                            <Switch>
                                <Route path={`${match.url}/reports`} component={asyncComponent(() => import('./routes/ReportsPage'))} />
                                <Route path={`${match.url}/archive`} component={asyncComponent(() => import('./routes/ArchivePage'))} />
                                <Route path={`${match.url}/settings`} component={asyncComponent(() => import('./routes/SettingsPage'))} />
                                <Route path={`${match.url}/report/:id`} component={asyncComponent(() => import('./routes/ReportPage'))} />
                                <Route path={`${match.url}/profile`} component={asyncComponent(() => import('./routes/ProfilePage'))} />
                                <Route component={asyncComponent(() => import('components/Error404'))} />
                            </Switch>
                        </div>
                        <Footer />
                    </main>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, general }) => {
    const { drawerType, navigationStyle, horizontalNavPosition } = settings;
    return { drawerType, navigationStyle, horizontalNavPosition, userRole: general.userProfile.role.id };
};
export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./app/index.js